import { Component, OnInit } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { FormGroup } from '@angular/forms';
import { currencyFormatter } from '@app/core/utils';

@Component({
  selector: 'app-num-pad',
  templateUrl: './num-pad.template.html'
})

export class NumPadComponent implements OnInit {
  public numpad_items: string[] = ['9', '8', '7', '6', '5', '4', '3', '2', '1', '0'];
  result = 0;
  range: any;

  question: QuestionBase<any>;
  form: FormGroup;
  currencyFormatter: any;

  ngOnInit() {
    this.range = this.question['options'].range;
    this.currencyFormatter = currencyFormatter;
  }

  onClickNumberButton(value: any) {
    const valueString = this.result ? this.result.toString() + value : value;
    this.result = parseFloat(valueString);
  }

  onClickDelButton() {
    this.result = this.result ? Math.floor(this.result / 10) : 0;
  }

  onClickEnterButton() {
    this.form.controls[this.question.key].setValue(this.result);
    this.question.value = this.result;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/num-pad/num-pad.component.ts